"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemverValidationError = exports.ValidationError = exports.MigrationError = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _es6Error = _interopRequireDefault(require("es6-error"));
var _stringifyNode = _interopRequireDefault(require("./lib/stringify-node"));
// eslint-disable-next-line max-classes-per-file
var MigrationError = /*#__PURE__*/function (_ExtendableError) {
  (0, _inherits2.default)(MigrationError, _ExtendableError);
  var _super = (0, _createSuper2.default)(MigrationError);
  function MigrationError() {
    (0, _classCallCheck2.default)(this, MigrationError);
    return _super.apply(this, arguments);
  }
  return MigrationError;
}(_es6Error.default);
exports.MigrationError = MigrationError;
var ValidationError = /*#__PURE__*/function (_ExtendableError2) {
  (0, _inherits2.default)(ValidationError, _ExtendableError2);
  var _super2 = (0, _createSuper2.default)(ValidationError);
  function ValidationError(node) {
    var _this;
    (0, _classCallCheck2.default)(this, ValidationError);
    var message = (0, _stringifyNode.default)(node);
    _this = _super2.call(this, message);
    _this.message = "node not valid: ".concat(message);
    return _this;
  }
  return ValidationError;
}(_es6Error.default);
exports.ValidationError = ValidationError;
var SemverValidationError = /*#__PURE__*/function (_ValidationError) {
  (0, _inherits2.default)(SemverValidationError, _ValidationError);
  var _super3 = (0, _createSuper2.default)(SemverValidationError);
  function SemverValidationError(message) {
    var _this2;
    (0, _classCallCheck2.default)(this, SemverValidationError);
    _this2 = _super3.call(this, message);
    _this2.message = "Invalid simple semver: ".concat(message);
    return _this2;
  }
  return SemverValidationError;
}(ValidationError);
exports.SemverValidationError = SemverValidationError;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJNaWdyYXRpb25FcnJvciIsIkV4dGVuZGFibGVFcnJvciIsIlZhbGlkYXRpb25FcnJvciIsIm5vZGUiLCJtZXNzYWdlIiwic3RyaW5naWZ5Tm9kZSIsIlNlbXZlclZhbGlkYXRpb25FcnJvciJdLCJzb3VyY2VzIjpbIi4uL3NyYy9lcnJvcnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIG1heC1jbGFzc2VzLXBlci1maWxlXG5pbXBvcnQgRXh0ZW5kYWJsZUVycm9yIGZyb20gJ2VzNi1lcnJvcic7XG5pbXBvcnQgc3RyaW5naWZ5Tm9kZSBmcm9tICcuL2xpYi9zdHJpbmdpZnktbm9kZSc7XG5cbmltcG9ydCB0eXBlIHsgU3RydWN0dXJlZENvbnRlbnRDaGlsZCB9IGZyb20gJy4vdHlwZXMvbm9kZSc7XG5cbmV4cG9ydCBjbGFzcyBNaWdyYXRpb25FcnJvciBleHRlbmRzIEV4dGVuZGFibGVFcnJvciB7fVxuXG5leHBvcnQgY2xhc3MgVmFsaWRhdGlvbkVycm9yIGV4dGVuZHMgRXh0ZW5kYWJsZUVycm9yIHtcbiAgY29uc3RydWN0b3Iobm9kZTogU3RydWN0dXJlZENvbnRlbnRDaGlsZCkge1xuICAgIGNvbnN0IG1lc3NhZ2UgPSBzdHJpbmdpZnlOb2RlKG5vZGUpO1xuICAgIHN1cGVyKG1lc3NhZ2UpO1xuICAgIHRoaXMubWVzc2FnZSA9IGBub2RlIG5vdCB2YWxpZDogJHttZXNzYWdlfWA7XG4gIH1cbn1cblxuZXhwb3J0IGNsYXNzIFNlbXZlclZhbGlkYXRpb25FcnJvciBleHRlbmRzIFZhbGlkYXRpb25FcnJvciB7XG4gIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZykge1xuICAgIHN1cGVyKG1lc3NhZ2UpO1xuICAgIHRoaXMubWVzc2FnZSA9IGBJbnZhbGlkIHNpbXBsZSBzZW12ZXI6ICR7bWVzc2FnZX1gO1xuICB9XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFDQTtBQUNBO0FBRkE7QUFBQSxJQU1hQSxjQUFjO0VBQUE7RUFBQTtFQUFBO0lBQUE7SUFBQTtFQUFBO0VBQUE7QUFBQSxFQUFTQyxpQkFBZTtBQUFBO0FBQUEsSUFFdENDLGVBQWU7RUFBQTtFQUFBO0VBQzFCLHlCQUFZQyxJQUE0QixFQUFFO0lBQUE7SUFBQTtJQUN4QyxJQUFNQyxPQUFPLEdBQUcsSUFBQUMsc0JBQWEsRUFBQ0YsSUFBSSxDQUFDO0lBQ25DLDJCQUFNQyxPQUFPO0lBQ2IsTUFBS0EsT0FBTyw2QkFBc0JBLE9BQU8sQ0FBRTtJQUFDO0VBQzlDO0VBQUM7QUFBQSxFQUxrQ0gsaUJBQWU7QUFBQTtBQUFBLElBUXZDSyxxQkFBcUI7RUFBQTtFQUFBO0VBQ2hDLCtCQUFZRixPQUFlLEVBQUU7SUFBQTtJQUFBO0lBQzNCLDRCQUFNQSxPQUFPO0lBQ2IsT0FBS0EsT0FBTyxvQ0FBNkJBLE9BQU8sQ0FBRTtJQUFDO0VBQ3JEO0VBQUM7QUFBQSxFQUp3Q0YsZUFBZTtBQUFBIn0=